export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Szukaj"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jesteś w trybie demonstracyjnym. Salda i operacje są szkoleniowe."])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Przejdź do gabinetu roboczego"])}
}